import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_PETITION_MARQUEE = defineFcm('homepage_petition_marquee')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				petitions: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							petitionId: { type: 'number' },
							summarizedTitle: { type: 'string' },
							// optional so entries curated before this flag existed keep normalizing
							usePetitionPhoto: { type: 'boolean', optional: true },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		petitions: [],
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-middle-end',
		supportedGroups: { countries: true },
		context: 'Homepage petition marquee',
		description:
			'Curated petitions shown in the homepage marquee. Each entry pairs a petition ID with a short summarized title used in place of the petition ask; the petition image and signature count are pulled from the petition itself. Cards use the starter’s avatar and fall back to the petition photo when there is no avatar - set usePetitionPhoto to true when a starter’s avatar is an auto-generated letter rather than a real photo, and the card will use the petition photo instead (the entry is skipped if that petition has no photo).',
		import: false,
		template: {
			isEnabled: true,
			petitions: [
				{
					petitionId: 123456,
					summarizedTitle: 'Protect the national parks',
					usePetitionPhoto: false,
				},
			],
		},
	});
